module.exports = __webpack_public_path__ + "img/jaime-delgado.f37ca4de.png";